import React, { useRef, useEffect, useState } from 'react';
import { getAttr } from './Row';
import { apiServerHost, imageServerHost } from '../common/APIServerSettings';
import Slider from 'react-slick'

import './NormalComponents.css'
import { slick_settings } from './SliderSettings';

const NormalComponents = (props) => {
  const slickRef = useRef()
  const { editSlidePageIndex, currentEditSlidePage, effectFlag, col } = props

  useEffect(() => {
    // setPrevEditSlidePageIndex(editSlidePageIndex)
    if (slickRef && effectFlag ) {
      if (slickRef.current) {
        console.log(editSlidePageIndex)
        // Slick의 애니메이션이 랜더링 간섭을 받아 setTimeout 걸어주었음
        setTimeout((slickRef_current) => {
          if (slickRef_current) {
            try{
              slickRef_current.slickGoTo(editSlidePageIndex)
            } catch (e) {
              console.error('채팅 미리보기의 슬라이드를 현재 수정중인 슬라이드로 움직이지 못하였습니다.')
              console.error('Error info :', e)
              console.info('Slider DOM reference :', slickRef_current);
            }
          }
        }, 50, slickRef.current)
      }
    }
  }, [editSlidePageIndex])

  return (
    renderNormalComponents(props, slickRef)
  )
}

const renderNormalComponents = (props, slickRef) => {
  const {attr, layout, components, col, fillRemainCol} = props
  
  if (layout !== "default") {
    switch(layout) {
      case "slide":
        return renderNormalComponents_slide(props, slickRef)
  
      default:
        window.alert(layout, "은 정의되지 않은 Layout입니다.")
        return (<p> {layout} 은 정의되지 않은 Layout입니다. 레이아웃 정보를 확인해주세요 </p>)
    }
  }

  if (1 < col) {
    return renderNormalComponents_grid(props)
  }
  
  return renderNormalComponents_default(props, slickRef)
}

const renderNormalComponents_default = (props, slickRef) => {
  const {attr, layout, components, col, fillRemainCol, editMessageIndex, editRowIndex, editSlidePageIndex, effectFlag} = props

  const getAttr_result = getAttr(attr)
  switch(getAttr_result.child) {
    case "TEXT":
      return components.map(component => (
        <div className="chat_service_board_cpnt" style={text_style}> {component.value} </div>
      ))
    case "BUTTON":
      return components.map(component => (
        <button className="chat_service_board_cpnt" style={button_style}>
          {component.name}
        </button>
      ))     
    case "IMAGE":
        return components.map(component => (
          <div className="chat_service_board_cpnt" >
            <img src={`${imageServerHost}/service/img?name=${component.resource}`}
              alt={component.name}
              style={image_style} 
            />
            {
              component.name && (
                component.name.trim() !== "" && (
                  <div style={image_title_style}> <span style={{display:'table-cell', verticalAlign: 'middle'}}>{component.name}</span> </div>
                )
              )
            }
          </div>
        ))
    case "GROUP":
      return (
        <Slider ref={slickRef} {...slick_settings}>
          {
            components.map((component, i) => {
              const { currentEditSlidePage } = props
              // 현재 수정하고있는 슬라이드 페이지 rows 분기
              const isEditing = currentEditSlidePage && editSlidePageIndex === i
              const rows = isEditing && effectFlag ? currentEditSlidePage.rows : component.rows
              
              return (
                <div>
                {/* <div className={isEditing && "edit-highlight"}> */}
                  {
                    rows.map(row => {
                      return renderNormalComponents(row)
                    })
                  }
                </div>
              )
            })
          }
        </Slider>
      ) 
      
    default:
      return (
        <p> {getAttr_result.child}은 정의되지 않은 컴포넌트 타입 </p>
      )
  }
}

const renderNormalComponents_grid = (props) => {
  const {attr, layout, components, col, fillRemainCol} = props
  
  const getAttr_result = getAttr(attr)
    
  const must_render_rows_count = Math.ceil(components.length / col)
  const last_row_components_length = components.length % col
  const calculated_render_array = []
  let col_num = col

  try {
    col_num = parseInt(col_num)
  } catch (e) {
    console.log('ChatPreview - row column parseInt error ', e)
    console.error(e)
  }
  const col_classname = ((col_num) => {
    switch(col_num) {
      case 2:
        return 'col-6'
      case 3:
        return 'col-4'
      default:
        console.error(col, "이라는 개수의 컬럼은 정의되지 않았음 (col-4로 표기 되어짐)")
        return 'col-4'
    }
  })(col_num)
  let component_count = 0 // Use in col loop part for reference components
  for (let row_count=0; row_count < must_render_rows_count; row_count++) {
    const col_result = []
    for (let col_count=0; col_count < col; col_count++) {
      // 랜더링 할 타겟 컴포넌트
      const render_target_component = components[component_count] ? components[component_count] : null
      // 고정된 col.length 랜더링에 따라 랜더링 타겟 컴포넌트가 없을 시 랜더링을 막음
      if (!render_target_component) {
        continue
      }
      // Component 랜더링
      const rendered_component = render_gridable_component(getAttr_result.child, render_target_component)

      // 마지막 Row 검사
      if (row_count+1 === must_render_rows_count) {
        // console.log(row_count+1, '===', must_render_rows_count, ' => ', true)
        // 마지막 Component 검사
        if (col_count === last_row_components_length-1) {
          // fillRemainCol option 적용 여부
          if (fillRemainCol) {
            const col_className_remainCols = get_column_className_by_remainCols(last_row_components_length)
            col_result.push(
              <div className={col_className_remainCols} style={grid_common_style}>
                {rendered_component}
              </div>
            )
            component_count++
            continue
          }
        }
      }
      col_result.push(
        <div className={col_classname} style={grid_common_style}>
          {rendered_component}
        </div>
      )
      component_count++
    }
    calculated_render_array[row_count] = col_result
  }

  return (
    <div style={grid_row_style}>
      {
        calculated_render_array.map(row => (
          <div className="row" style={{borderBottom: 'none', marginLeft: -2.5, marginRight: -2.5}}>
            {
              row.map(col => (
                col
              ))
            }
          </div>
        ))
      }
    </div>
  )
}
const render_gridable_component = (child_type, component) => {
  switch(child_type) {
    case "BUTTON":
      return (
        <button className="chat_service_board_cpnt" style={button_style}>
          {component.name}
        </button>
      )    

    case "IMAGE":
      return (
        <div className="chat_service_board_cpnt" >
          <img src={`${imageServerHost}/service/img?name=${component.resource}`}
            alt={component.name}
            style={image_style} 
          />
          {
            component.name && (
              component.name.trim() !== "" && (
                <div style={image_title_style}> <span style={{display:'table-cell', verticalAlign: 'middle'}}>{component.name}</span> </div>
              )
            )
          }
        </div>
      )
      
    default:
      return (
        <p> {child_type} is not defined </p>
      )
  }
}
const get_column_className_by_remainCols = (existColumns_count) => {
  switch(existColumns_count) {
    case 1:
      return 'col-12'
    case 2:
      return 'col-8'
    case 3:
      return 'col-4'
    default:
      console.error(existColumns_count, "이라는 개수의 컬럼은 정의되지 않았음 (col-4로 표기 되어짐)")
      return 'col-4'
  }
}

const renderNormalComponents_slide = (props, slickRef) => {
  const {attr, layout, components, col, fillRemainCol} = props
  const getAttr_result = getAttr(attr)
  switch(getAttr_result.child) {
    // case "TEXT":
    //   return components.map(component => (
    //     <p className="chat_service_board_cpnt" style={text_style}> {component.value} </p>
    //   ))      
    case "BUTTON":
      return (
        <Slider {...slick_settings}>
          {
            components.map(component => (
            <div>
              <button className="chat_service_board_cpnt" style={button_style}>
                {component.name}
              </button>
            </div>
          ))
          }
        </Slider>
      )      
    case "IMAGE":
        return (
          <Slider {...slick_settings}>
            {
              components.map(component => (
                <div>
                  <img className="chat_service_board_cpnt" src={`${imageServerHost}/service/img?name=${component.resource}`}
                    alt={component.name}
                    style={image_style} />
                  {
                    component.name && (
                      component.name.trim() !== "" && (
                        <div style={image_title_style}> <span style={{display:'table-cell', verticalAlign: 'middle'}}>{component.name}</span> </div>
                      )
                    )
                  }
                </div>
              ))
            }
          </Slider>
        )    
    // case "GROUP":
    //   return (
    //     <Slider {...slick_settings}>
    //       {
    //         components.map(component => {
    //           const { rows } = component
              
    //           return (
    //             <div>
    //               {
    //                 rows.map(row => {
    //                   return renderNormalComponents_default(row)
    //                 })
    //               }
    //             </div>
    //           )
    //         })
    //       }
    //     </Slider>
    //   ) 
      
    default:
      return (
        <p> {getAttr_result.child}은 정의되지 않은 컴포넌트 타입 </p>
      )
  }
}

const text_style = {
  // wordBreak: 'break-all',
  whiteSpace: 'pre-line',
  overflowWrap: 'break-word',
}

export const button_style = {
  display: "block",
  width: "100%",
  fontSize: 13,
  color: "#ffffff",
  minHeight: 35,
  // lineHeight: 22,
  textAlign: "center",
  boxSizing: "border-box",
  background: "#236bb0",
  borderRadius: 2.5,
  border: 0,
}

export const image_style = {
  width: "100%",
  // maxHeight: 200,
  minHeight: 150,
  border: '1px solid #ccc',
  // borderBottom: 'none',
}
const image_title_style = {
  width: '100%',
  display: 'table',
  minHeight: 35,
  textAlign: 'center',
  border: '1px solid #ccc',
  borderTop: 'none',
  borderBottomLeftRadius: 5,
  borderBottomRightRadius: 5,
  wordBreak: 'break-word',
  whiteSpace: 'normal',
}

/**
 * Row styles
 */
const grid_row_style = {
  width: '100%',
  borderBottom: 'none',
}

const grid_common_style = {
  paddingLeft: 2.5,
  paddingRight: 2.5,
}

export default NormalComponents